// extracted by mini-css-extract-plugin
export var legendIndicator = "_g8-1";
export var legendRight = "_g8-0";